import {
  Avatar,
  Box,
  Button,
  ButtonGroup,
  Center,
  HStack,
  IconButton,
  Image,
  Stack,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import React from "react";
import GeneialPng from "../../../assets/icon.png";
import RedCapPng from "../../../assets/redcap_logo.png";
import { MaterialIcon } from "../../../components/shared/MaterialIcon";
import { IRegistry, RegistryTypeEnum } from "../models/Registry";

interface IProps {
  registry: IRegistry;
  onOpen: () => void;
  onEdit?: () => void;
  onViewData?: () => void;
}

const RegistryCard = ({ registry, onOpen, onEdit, onViewData }: IProps) => {
  const [registryTypeImage, setRegistryTypeImage] = React.useState<any>("");

  const handleOnEdit = (evt) => {
    evt.stopPropagation();
    if (onEdit) {
      onEdit();
    }
  };
  const handleOnViewData = (evt) => {
    evt.stopPropagation();
    if (onViewData) {
      onViewData();
    }
  };

  React.useEffect(() => {
    let registryTypeImageUpdate = "";

    if (registry.registry_type === RegistryTypeEnum.REDCAP) {
      registryTypeImageUpdate = RedCapPng;
    } else if (registry.registry_type === RegistryTypeEnum.GENEIAL_S3) {
      registryTypeImageUpdate = GeneialPng;
    }

    setRegistryTypeImage(registryTypeImageUpdate);
  }, [registry]);

  return (
    <Box
      h="full"
      w="full"
      border={"1px"}
      rounded="md"
      minH={"24rem"}
      px={8}
      pt={8}
      pb={4}
      onClick={onOpen}
      bg="bg.main"
      borderColor="border"
      cursor={"pointer"}
      shadow="sm"
      _hover={{
        color: "text",
        bg: "bg.high",
      }}
    >
      <Stack h="full" spacing={6} alignItems="center">
        <Center flex={1} w="full" maxH="56" minH="56">
          {registry.registry_brand_url && (
            <Box
              w="full"
              h="full"
              borderWidth={"1px"}
              rounded="md"
              overflow={"hidden"}
            >
              <Image
                objectFit={"cover"}
                h="full"
                w="full"
                src={registry.registry_brand_url}
              ></Image>
            </Box>
          )}

          {!registry.registry_brand_url && (
            <MaterialIcon
              color="text.primary"
              name="diversity_2"
              fontSize="6rem"
            />
          )}
        </Center>

        <Stack spacing="1" flex={1}>
          <Text fontWeight="bold" fontSize="xl" textAlign={"center"}>
            {registry.title}
          </Text>
          <Text
            noOfLines={2}
            fontSize="md"
            textAlign={"center"}
            color="text.soft"
          >
            {registry.description}
          </Text>
        </Stack>
        <HStack justifyContent={"space-between"} w="full">
          <HStack>
            {onEdit && (
              <Tooltip label="Edit Registry">
                <IconButton
                  size="sm"
                  variant={"outline"}
                  onClick={handleOnEdit}
                  icon={<MaterialIcon name="settings" fontSize="1rem" />}
                  aria-label="settings"
                ></IconButton>
              </Tooltip>
            )}
            {registry?.abbreviation && (
              <Tooltip label="View Public Stats">
                <IconButton
                  size="sm"
                  variant={"outline"}
                  onClick={handleOnViewData}
                  icon={
                    <MaterialIcon
                      name="show_chart"
                      variant="outline"
                      fontSize="1.5rem"
                    />
                  }
                  aria-label="settings"
                ></IconButton>
              </Tooltip>
            )}
            <Tooltip label="Registry type">
              <Avatar
                name={registry.registry_type}
                src={registryTypeImage}
                size="sm"
              ></Avatar>
            </Tooltip>
          </HStack>

          <ButtonGroup
            size="sm"
            variant={"outline"}
            flex={1}
            spacing={4}
            justifyContent="flex-end"
          >
            <Button
              onClick={onOpen}
              rightIcon={
                <MaterialIcon name="arrow_right_alt" fontSize="1rem" />
              }
            >
              Open
            </Button>
          </ButtonGroup>
        </HStack>
      </Stack>
    </Box>
  );
};

export default RegistryCard;
